import type { FaireProductEntity } from "../../entity_types/product";

export const p_hwvjcnw9tx: FaireProductEntity = {
  token: "p_hwvjcnw9tx",
  type: "product",
  name: "Green Coat Lady",
  brandToken: "b_sskrdryawp",
  brandName: "Someday Studio",
  imageUrl: "https://cdn.faire.com/fastly/6c438a55dfcab14ef5b0cd31f6e11e3c96cfdadd61292fdbbc3d447d89d9c9e9.png",
  galleryImageUrls: [],
  priceDollars: 2.97,
  description: "I’m so glad I live in a world where there’s a you.\n\n• Blank inside\n• Foil details\n• Size: A2 folded 4.25” x 5.5”\n• Envelope: open end with multi-color flecks",
  tags: [],
  msrpDollars: 5.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:58.745Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
